import { useTranslation } from "next-i18next";

import { Button } from "@/ui/cva/Button";

type AccountLoadErrorProps = {
  /** What could not be loaded; a general line when left out. */
  message?: string;
  onRetry: () => void;
};

/**
 * WHO-6629 F28. A load that failed (the gateway down, a firewall challenge)
 * says so, with a way to try again. It never falls through to an empty state:
 * "Je hebt nog geen favorieten" for someone with eight reads as lost data.
 */
export const AccountLoadError = ({
  message,
  onRetry,
}: AccountLoadErrorProps) => {
  const { t } = useTranslation();

  return (
    <div
      role="alert"
      className="flex flex-col items-start gap-3 rounded-[10px] border border-grey-200 p-4"
    >
      <p className="font-body text-base text-black">
        {message ??
          t(
            "account:account-load-error",
            "This could not be loaded right now."
          )}
      </p>
      <Button
        type="button"
        color="brand"
        appearance="outlined"
        size="small"
        onClick={onRetry}
      >
        {t("common:common-try-again", "Try again")}
      </Button>
    </div>
  );
};
